module.exports = __webpack_public_path__ + "media/images/certificate/cert-bg-a35be5f2976e78dac55060666ae29eaf.svg";